---
title: "The best time to post on TikTok, measured across 5,311 videos"
description: "I analyzed 5,311 TikTok videos from 602 creators to find the best time to post. Timing barely moves it, and Saturday, the day most guides crown, ranks worst."
date: "2026-06-19"
author: "Kevin Wang"
tags: ["tiktok", "data-study", "social"]
keyword: "best time to post on tiktok"
ogImage: "/og/best-time-tiktok.png"
---

export const cell = (value, n) => ({ value, n });
export const bar = (label, value, n) => ({ label, value, n });

export const heatRows = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const hourCols = ["12a", "1a", "2a", "3a", "4a", "5a", "6a", "7a", "8a", "9a", "10a", "11a", "12p", "1p", "2p", "3p", "4p", "5p", "6p", "7p", "8p", "9p", "10p", "11p"];
export const heatData = [
  [cell(1.03,72), cell(1.07,60), cell(1.07,50), cell(1.07,54), cell(1.17,75), cell(1.16,76), cell(1.09,95), cell(1.02,121), cell(1.03,145), cell(1.00,147), cell(1.01,165), cell(1.01,170), cell(1.03,171), cell(1.00,166), cell(1.00,160), cell(0.96,172), cell(1.05,168), cell(1.05,158), cell(1.14,153), cell(1.13,152), cell(1.14,129), cell(1.04,114), cell(1.04,98), cell(0.95,84)],
  [cell(0.97,81), cell(1.00,70), cell(1.05,64), cell(1.04,76), cell(1.10,97), cell(1.13,111), cell(1.09,130), cell(1.07,153), cell(1.10,175), cell(1.02,192), cell(1.05,210), cell(1.07,210), cell(1.10,208), cell(1.08,208), cell(1.10,193), cell(1.09,170), cell(1.14,155), cell(1.09,140), cell(1.12,126), cell(1.09,121), cell(1.00,126), cell(1.00,129), cell(1.00,114), cell(0.88,91)],
  [cell(1.06,90), cell(1.05,78), cell(1.07,78), cell(1.04,90), cell(0.97,106), cell(1.00,107), cell(1.00,125), cell(1.00,144), cell(1.00,162), cell(1.07,173), cell(1.07,197), cell(1.00,203), cell(1.00,203), cell(1.00,209), cell(0.96,193), cell(0.96,182), cell(1.00,172), cell(1.01,156), cell(1.04,135), cell(1.02,135), cell(1.08,122), cell(1.06,119), cell(1.02,110), cell(1.02,96)],
  [cell(1.05,115), cell(1.08,101), cell(1.00,90), cell(1.00,106), cell(1.00,109), cell(1.00,121), cell(1.00,147), cell(1.00,163), cell(1.00,185), cell(1.00,205), cell(1.00,223), cell(1.00,227), cell(1.00,240), cell(1.00,235), cell(1.00,231), cell(1.00,229), cell(1.00,222), cell(1.00,203), cell(1.00,187), cell(1.00,187), cell(1.00,162), cell(0.99,158), cell(1.00,143), cell(1.00,131)],
  [cell(1.14,107), cell(1.10,97), cell(1.07,96), cell(1.07,104), cell(1.13,125), cell(1.10,144), cell(1.09,159), cell(1.00,188), cell(1.00,219), cell(1.00,256), cell(0.99,271), cell(1.00,289), cell(1.00,287), cell(1.00,284), cell(1.00,266), cell(1.00,262), cell(0.99,277), cell(0.97,259), cell(0.98,233), cell(1.00,213), cell(1.00,194), cell(1.22,156), cell(1.17,140), cell(1.24,124)],
  [cell(0.84,150), cell(0.89,132), cell(0.89,113), cell(0.89,122), cell(0.90,151), cell(0.97,170), cell(0.98,176), cell(0.97,192), cell(0.98,223), cell(1.00,242), cell(0.95,254), cell(0.86,295), cell(0.86,312), cell(0.85,305), cell(0.87,280), cell(0.88,286), cell(0.93,254), cell(0.96,243), cell(0.96,238), cell(0.90,258), cell(0.87,252), cell(0.85,254), cell(0.89,219), cell(0.86,189)],
  [cell(0.82,154), cell(0.84,152), cell(0.75,153), cell(0.82,126), cell(0.88,103), cell(1.09,87), cell(1.11,84), cell(1.11,91), cell(1.02,101), cell(1.00,107), cell(1.00,111), cell(1.00,119), cell(0.99,132), cell(1.00,131), cell(1.04,133), cell(1.03,126), cell(1.04,119), cell(1.11,101), cell(1.11,96), cell(1.05,78), cell(1.10,78), cell(1.10,75), cell(0.96,102), cell(0.89,126)],
];

export const weekdayData = [
  bar("Mon", 1.03, 591), bar("Tue", 1.05, 670), bar("Wed", 1.00, 677), bar("Thu", 1.00, 824),
  bar("Fri", 1.00, 950), bar("Sat", 0.90, 1062), bar("Sun", 1.00, 537),
];

export const hourData = [
  bar("12a", 0.98, 124), bar("1a", 0.91, 124), bar("2a", 0.97, 146), bar("3a", 1.11, 116), bar("4a", 1.00, 134),
  bar("5a", 1.00, 158), bar("6a", 1.05, 212), bar("7a", 1.00, 196), bar("8a", 1.04, 216), bar("9a", 0.99, 270),
  bar("10a", 1.00, 316), bar("11a", 1.01, 324), bar("12p", 1.00, 305), bar("1p", 0.96, 298), bar("2p", 1.00, 310),
  bar("3p", 0.99, 301), bar("4p", 1.00, 242), bar("5p", 1.00, 276), bar("6p", 1.05, 238), bar("7p", 1.01, 203),
  bar("8p", 1.00, 209), bar("9p", 0.98, 218), bar("10p", 1.00, 195), bar("11p", 1.05, 180),
];

export const satByTier = [
  bar("Nano", 1.00, 180), bar("Micro", 0.95, 250), bar("Mid", 0.87, 417), bar("Mega", 0.88, 215),
];

export const tierCreators = [
  { label: "Nano <50k", value: 150, color: "var(--c-blue)" },
  { label: "Micro 50k-500k", value: 181, color: "var(--c-violet)" },
  { label: "Mid 500k-5M", value: 201, color: "var(--c-teal)" },
  { label: "Mega 5M+", value: 70, color: "var(--c-amber)" },
];
export const tierVideos = [
  { label: "Nano", value: 1283, color: "var(--c-blue)" },
  { label: "Micro", value: 1567, color: "var(--c-violet)" },
  { label: "Mid", value: 1804, color: "var(--c-teal)" },
  { label: "Mega", value: 657, color: "var(--c-amber)" },
];

Every TikTok guide promises a single best hour to post. Open three of them and you get three different hours, each ranked on raw engagement, where a few huge accounts posting at the same time can invent a peak that more data erases. So I pulled **5,311 recent TikTok videos from 602 creators** and scored each against its own creator's baseline. **Timing barely moved it,** and Saturday, the day most guides crown, ranked worst.

<Callout type="tip" title="Key findings">

- **Timing barely moves engagement.** Most day-and-hour slots land within a few points of a creator's usual video.
- **Saturday is the one consistently weak day,** and the dip deepens the bigger your account is.
- **The hour you pick barely matters** during normal posting times, roughly 6am to midnight.
- **Under 50k followers, none of this showed up.** The smallest creators had no timing pattern at all.

</Callout>

I measured engagement in likes and scored every video against its own creator's median, so a big account's baseline doesn't drown out a smaller one's. The sample spans 54 niches and every follower tier, sorted by the weekday and hour each video went up, in US Eastern.

This is the full weekday-by-hour grid. Most cells land within a few points of a creator's normal video.

<Chart caption="Median engagement (creator-normalized likes) by weekday and hour, US Eastern, smoothed with a five-hour moving median. Blue beats the creator's norm, grey trails it. Hover a cell for its value and sample size. Every cell's five-hour window covers at least 50 videos.">
  <Heatmap
    rows={heatRows}
    cols={hourCols}
    data={heatData}
    showValues={false}
    colLabelStep={3}
    cellW={22}
    cellH={24}
    unit="ET"
    ariaLabel="Median TikTok engagement vs creator norm by US-Eastern weekday and hour, 5311 videos"
  />
</Chart>

## At a glance

| Question | What the data says |
| --- | --- |
| Best day | Tuesday, by a hair (1.05x a creator's normal) |
| Worst day | Saturday (0.90x), the one consistent dip |
| Best hour | No winner. Roughly flat from 6am to midnight |
| Does timing matter? | A little, and mostly as a Saturday penalty |
| Who should care | Accounts over 500k followers. Under 50k, ignore it |

## The day barely matters, and Saturday is the weak spot

Line up the seven days and six of them sit right around a creator's normal video. The exception is Saturday, at **0.90x**. A typical Saturday post lands about 10% below that creator's usual likes. Tuesday is nominally the best at 1.05x, but a 15-point spread between the best and worst day is not much to build a schedule on.

<Chart caption="Median engagement relative to each creator's own baseline, by weekday. Six days cluster near normal. Saturday is the one that trails (n=5,311).">
  <BarChart data={weekdayData} unit="ET" showValues ariaLabel="Median engagement by weekday" />
</Chart>

Saturday is cool across almost every hour, not just one slot. If you post daily, **skip Saturday first**. The other six days were too close to call.

## The hour barely matters

From 6am to midnight, every hour lands **within five points of a creator's normal**. The bigger swings, 0.91x at 1am or 1.11x at 3am, sit on the thinnest overnight data, where a handful of videos can move the median.

<Chart caption="Median engagement vs. each creator's normal, by hour (US Eastern). Nearly flat through the day, with the only real swings overnight on small samples (n=5,311).">
  <BarChart data={hourData} unit="ET" labelStep={3} ariaLabel="Median engagement by hour" />
</Chart>

There is **no 6pm peak** here, and no lunchtime one either. The overnight bumps are most likely posts on a timer, going out while their creators sleep. If a better hour exists for your audience, it is small enough that only your own posts will show it.

## The coldest cells: Saturday, and Sunday before sunrise

Put day and hour together and there are two cold regions. Saturday runs cool from late morning into the evening. The coldest cells of all are Sunday in the small hours, bottoming out near **0.75x** around 2am before warming up after sunrise. Weekday daytime is unremarkable, close to a creator's normal the whole way through.

The warm cells are scattered, mostly **late Friday evenings, 9 to 11pm**, the only cells that reach about 1.2x. Test them on your own account before you trust them.

## Saturday mostly hurts bigger accounts

The Saturday dip changes by follower tier. Split it by follower count and it **barely touches the smallest creators** while it lands hardest on mid-size and large ones.

<Chart caption="Saturday engagement vs. each creator's own normal, by follower tier. Nano creators show no dip. The hit lands hardest on mid-size and large accounts (n=5,311).">
  <BarChart data={satByTier} showValues ariaLabel="Saturday engagement by follower tier" />
</Chart>

- **Nano (under 50k):** no dip. Saturday looks like any other day.
- **Micro (50k to 500k):** a slight dip, to 0.95x.
- **Mid (500k to 5M):** the deepest, **0.87x**.
- **Mega (5M and up):** about the same, 0.88x.

If you have under 50k followers, **I didn't find a weekday signal at all**. The Saturday dip shows up above 50k and is deepest above 500k. I don't have a clean explanation for why it concentrates in larger accounts, only that the pattern held across the sample.

## Why thin data invents a best time

Most "best time to post" charts promise a precise hour. The problem is sample size: any single hour on a single day holds only a slice of posts, and **one creator's breakout in that slice can look like a real pattern**. A chart built on those thin buckets will hand you a confident peak that more data erases.

That is why each cell here is smoothed over a five-hour window, so a spike has to survive its neighbors to show up. What is left is a rough shape, and I wouldn't trust it down to the minute.

## How this compares to the big studies

The big published studies disagree with each other:

- [Buffer](https://buffer.com/resources/best-time-to-post-on-tiktok/) analyzed 7.1 million posts and named **Saturday** the best day. My data puts it last.
- [Sprout Social](https://sproutsocial.com/insights/best-times-to-post-on-tiktok/) points to weekday afternoons, **Tuesday through Thursday, 2 to 6pm**.
- [Hootsuite](https://blog.hootsuite.com/best-time-to-post-on-social-media/) lands on **Thursday, 7 to 11am**.

When the big studies land on different days and hours, the effect is small enough to bend with method. Mine scores each video against its own creator's baseline, where these studies rank raw engagement by post time. A few huge accounts posting at the same hour can make that hour look better than it is.

## How I measured it, and who I ran it on

I ran this on **602 creators across 54 niches and every follower tier**, and pulled their recent videos. Here is how the sample breaks down.

<Chart caption="The sample: 602 creators by follower tier (left), and the 5,311 videos they account for (right). Mid-size accounts are the best represented, so they carry the most weight in the results.">
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', alignItems: 'center' }}>
    <div style={{ flex: '1 1 300px', maxWidth: '360px' }}>
      <DonutChart data={tierCreators} centerLabel="602" centerSub="creators" ariaLabel="Creators sampled by follower tier" />
    </div>
    <div style={{ flex: '1 1 300px', maxWidth: '360px' }}>
      <DonutChart data={tierVideos} centerLabel="5,311" centerSub="videos" ariaLabel="Videos analyzed by follower tier" />
    </div>
  </div>
</Chart>

The procedure:

1. **Sample creators across the spectrum.** I searched 54 niches (cooking, finance, gaming, beauty, sports, parenting, and so on) with English keyword queries and pulled creators from every follower tier, in the mix shown above.
2. **Pull recent videos** for each creator, with the post timestamp and like count, going back about 18 months.
3. **Normalize per creator.** Score every video against its own creator's median likes, then cap each score at 6x so one viral hit counts once instead of dragging a whole cell up.
4. **Bucket and smooth.** Convert to US Eastern, group by weekday and hour, and set each cell to the median of every video in a five-hour window around that hour (two on each side, wrapping past midnight). The smoothing keeps a thin 3am cell from jumping on two lucky posts.

I collected the data in June 2026. The whole crawl cost **$2.21**: roughly 1,100 calls to the [`tiktok.profile_videos` and `tiktok.search_users`](/api/tiktok) endpoints across two passes, at the $0.002 a call they cost then. Both are in the full [TikTok endpoint rundown](/blog/how-to-scrape-tiktok), with the exact request for each. The same recipe runs on your own niche, or on [Instagram](/api/instagram) and [X](/api/x-twitter), and gives you a chart for *your* audience instead of a generic one. {/* receipt 2026-06-19 */}

## The limits of this data

- These are patterns, not proof. I can't fully tell a good posting time apart from creators simply posting their better videos at certain times.
- I counted likes against each creator's own typical video, not raw reach or how hard the For You page pushed a clip.
- Older videos have had more time to collect likes, which I didn't adjust for, so treat small gaps loosely.
- The 5,311 videos come from 602 creators, so a different set of creators could shift the weak-Saturday read.
- Everything is in US Eastern, and I didn't account for where each creator's audience actually lives. If yours leans West Coast or international, slide the times to match.

In this sample, timing moved engagement less than 10 points on most days. Saturday was the exception.

## How to find your own best time

Use this study to avoid Saturday, and use your own posts to pick an hour. My chart is US Eastern across 602 mixed creators. If your audience is West Coast, student-heavy, or mostly outside the US, treat it as a rough prior and rebuild it from your own account.

1. **Skip Saturday if you're past 50k, and don't sweat the hour.** Below that I didn't find a timing signal worth chasing, so spend the effort on format instead.
2. **Pull your own videos.** Run the same two endpoints against your own handle, or against a tighter slice of your niche than my 54.
3. **Compare each video to your own typical post.** That way one breakout hit doesn't invent a fake best time for you.
4. **Change one thing at a time.** Give a new posting slot a few weeks before you trust it, and hold your cadence steady while you test.

## Frequently asked questions

**What is the best time to post on TikTok?**

There isn't a single one. Across 5,311 videos, no hour stood out between 6am and midnight, and the best day (Tuesday) beat the average by only five points. The clearest signal is which time to avoid: Saturday.

**Does posting time matter on TikTok?**

Less than most guides claim. For accounts under 50k followers I found no weekday pattern at all. Above 500k, a Saturday post ran about 10% below the creator's own normal. In this crawl the clock moved most buckets only a few points, so I'd test format and cadence before chasing a posting minute.

**What is the worst time to post on TikTok?**

In this sample, Saturday, plus the small hours of Sunday. Saturday trailed every other day, and Sunday between roughly midnight and sunrise held the single coldest cells, down to 0.75x.

**What is the best day to post on TikTok?**

Tuesday edged the rest at 1.05x a creator's normal video, but the spread between the best and worst day was only 15 points. The clearer signal is the day to avoid: Saturday, at 0.90x.

**Why do other studies name a different best time?**

Buffer named Saturday, Sprout Social points to weekday afternoons, and Hootsuite lands on Thursday mornings. When the big studies disagree, the effect is small enough to bend with method. Mine scores each video against its own creator's baseline, where ranking raw engagement lets a few huge accounts make their posting hour look better than it is.

<CTA to="/catalog" note="The TikTok, Instagram, X, and 200+ other data endpoints behind this study. One key, priced in dollars, and new accounts start with free credit to run a study like this one.">
  Run your own study on the data catalog
</CTA>
